export default __webpack_public_path__ + "static/media/img_14.287fcd34.JPG";